import React, { useState } from "react";
import "../styles/FYSelectionModal.css";

function getSevenFinancialYears() {
  const now = new Date();
  // FY starts April 1. If we're in Jan-Mar, current FY started last year.
  const calYear = now.getMonth() >= 3 ? now.getFullYear() : now.getFullYear() - 1;
  // Center the list: 3 past, current, 3 future
  const startYear = calYear - 3;
  const years = [];
  for (let i = 0; i < 7; i++) {
    const y = startYear + i;
    years.push(`FY ${String(y).slice(-2)}-${String(y + 1).slice(-2)}`);
  }
  return years;
}

function FYSelectionModal({ onSelect }) {
  const years = getSevenFinancialYears();
  // Default to FY 2025-26
  const DEFAULT_FY = 'FY 25-26';
  const defaultIdx = years.indexOf(DEFAULT_FY);
  const [selectedIdx, setSelectedIdx] = useState(defaultIdx !== -1 ? defaultIdx : 3);

  const handleConfirm = () => {
    const fy = years[selectedIdx];
    localStorage.setItem("financial_year", fy);
    onSelect(fy);
  };

  return (
    <div className="fy-overlay">
      <div className="fy-modal">
        <div className="fy-header">
          <div className="fy-icon">📅</div>
          <h2 className="fy-title">Select Financial Year</h2>
        </div>

        <div className="fy-dial-wrapper">
          <div className="fy-dial">
            {years.map((fy, idx) => {
              const offset = idx - selectedIdx;
              const isActive = offset === 0;
              const isNear = Math.abs(offset) === 1;
              const isFar = Math.abs(offset) === 2;
              const isHidden = Math.abs(offset) > 2;

              return (
                <div
                  key={fy}
                  className={`fy-item ${isActive ? "fy-active" : ""} ${isNear ? "fy-near" : ""} ${isFar ? "fy-far" : ""} ${isHidden ? "fy-hidden" : ""}`}
                  onClick={() => setSelectedIdx(idx)}
                  style={{
                    transform: `translateY(${offset * 52}px) scale(${isActive ? 1 : isNear ? 0.84 : 0.7})`,
                    opacity: isHidden ? 0 : isActive ? 1 : isNear ? 0.7 : 0.35,
                    zIndex: isActive ? 10 : isNear ? 5 : 1,
                  }}
                >
                  <span className="fy-label">{fy}</span>
                </div>
              );
            })}
          </div>

          {/* Navigation arrows */}
          <button
            className="fy-arrow fy-arrow-up"
            onClick={() => setSelectedIdx((i) => Math.max(0, i - 1))}
            disabled={selectedIdx === 0}
            aria-label="Previous year"
          >
            ▲
          </button>
          <button
            className="fy-arrow fy-arrow-down"
            onClick={() => setSelectedIdx((i) => Math.min(years.length - 1, i + 1))}
            disabled={selectedIdx === years.length - 1}
            aria-label="Next year"
          >
            ▼
          </button>
        </div>

        <button className="fy-confirm-btn" onClick={handleConfirm}>
          Continue →
        </button>

        <p className="fy-note">
          Data is isolated per financial year. Evidence uploaded in one year will not appear in another.
        </p>
      </div>
    </div>
  );
}

export default FYSelectionModal;
